module.exports = __webpack_public_path__ + "static/media/wels-catfish.7170d612.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/wels-catfish.png
// module id = 339
// module chunks = 0